module.exports = __webpack_public_path__ + "img/farming-by-numbers--hen.ba78f17a.png";